import { Box, Button, Typography } from "@mui/material";
import {
  Carrousel,
  CarrouselWith4cards,
} from "../../../components/AtomicDesign/Molecules";
import { useEffect, useState } from "react";
import { getHomeInfo } from "../../../services/productsService";
import { useBreakpoints } from "../../../hooks/useBreakpoins";
import useGlobalLoading from "../../../hooks/context/useGlobalLoading";
import Prancheta2 from "../../../assets/images/Prancheta 2.png";
import Prancheta3 from "../../../assets/images/Prancheta 3.png";
import Prancheta4 from "../../../assets/images/Prancheta 4.png";
import CoelhoCartola from "../../../assets/images/coelho/coelho-cartola.png";
import BolinhasBanner from "../../../assets/images/coelho/bolinhas-banner.png";
import { colors } from "../../../theme/colors";
import { useNavigate } from "react-router-dom";

const listmock = [
  {
    id: 1,
    link: "/products?tab=1",
    photo: Prancheta2,
    title: "",
    subTitle: "",
    buttonName: "",
  },
  {
    id: 1,
    link: "/products?tab=1",
    photo: Prancheta3,
    title: "",
    subTitle: "",
    buttonName: "",
  },
  {
    id: 1,
    link: "/products?tab=1",
    photo: Prancheta4,
    title: "",
    subTitle: "",
    buttonName: "",
  },
];

type ProductWithoutCategories = Omit<ProductData, "Versions" | "Origin">[];

export function Home() {
  const { setOpenLoading } = useGlobalLoading();
  const { isSmalldesktop, isMobile } = useBreakpoints();
  const nav = useNavigate();
  const [homeInfo, setHomeInfo] = useState(
    {} as {
      mostAccess: ProductWithoutCategories;
      latestPrds: ProductWithoutCategories;
      carrousel: Banner[];
      productCategories: {
        versions: ProductsType[];
        origins: ProductsType[];
        productType: ProductsType[];
      };
    }
  );

  const getInfo = async () => {
    setOpenLoading(true);
    try {
      const response = await getHomeInfo();
      setHomeInfo(response);
    } catch {
    } finally {
      setOpenLoading(false);
    }
  };

  useEffect(() => {
    getInfo();

    // eslint-disable-next-line
  }, []);

  // const Categories = () => (
  //   <Box
  //     display="flex"
  //     flexDirection={"column"}
  //     width={isSmalldesktop ? "95%" : "19.5%"}
  //     gap={1}
  //     mt={1}
  //   >
  //     <PopularCategories
  //       list={homeInfo?.productCategories?.productType}
  //       linkTo="productTypeName"
  //       title="product types"
  //     />
  //     <PopularCategories
  //       list={homeInfo?.productCategories?.manufacturers}
  //       linkTo="manufacturerName"
  //       title="manufacturers"
  //     />
  //     <PopularCategories
  //       list={homeInfo?.productCategories?.origins}
  //       linkTo="originName"
  //       title="origins"
  //     />
  //     <PopularCategories
  //       list={homeInfo?.productCategories?.versions}
  //       linkTo="versionName"
  //       title="versions"
  //     />
  //   </Box>
  // );

  const CarrouselCp = () => (
    <Box width={"100%"}>
      <Carrousel list={listmock} />
    </Box>
  );

  const ProductsJPhere = () => (
    <Box
      sx={{
        background: colors.purpleAlpha[300],
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        pb: 10,
        pt: 5,
        gap: 3,
        marginTop: -4,
      }}
    >
      <img
        src={CoelhoCartola}
        alt="coelho cartola"
        width={isSmalldesktop ? 65 : 135}
      />
      <Typography
        sx={{
          fontSize: isSmalldesktop ? 25 : 60,
          fontWeight: 500,
          color: colors.black[400],
          pr: 5,
          pl: 5,
        }}
      >
        Importados do Japão agora no Brasil!
      </Typography>
      <Typography
        sx={{
          fontSize: isSmalldesktop ? 15 : 36,
          fontWeight: 400,
          color: colors.black[400],
          pr: 5,
          pl: 5,
        }}
      >
        Compre os exclusivos mais desejados livre de taxas
      </Typography>
      <Button
        sx={{ width: 344, height: 50, fontSize: 14, fontWeight: 600, mt: 2 }}
        variant="contained"
        onClick={() => nav("/products?tab=1")}
      >
        Confira todos nossos produtos!
      </Button>
    </Box>
  );

  const bolinhasW = () => {
    if (isMobile) return "90%";
    if (isSmalldesktop) return "70%";
    return "50%";
  };

  return (
    <Box
      display={"flex"}
      width={"100%"}
      alignItems={"flex-start"}
      flexDirection={"column"}
      overflow={"hidden"}
    >
      <CarrouselCp />
      <ProductsJPhere />
      <CarrouselWith4cards
        sectionList={homeInfo?.mostAccess}
        greyTitle="Os mais vistos"
        purpleSubTitle="Confira os produtos mais procurados"
      />
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"center"}
        mt={3}
        mb={3}
        sx={{ background: colors.purpleAlpha[300], pt: 5, pb: 5 }}
      >
        <img src={BolinhasBanner} width={bolinhasW()} alt="bolinhas banner" />
      </Box>

      <CarrouselWith4cards
        sectionList={homeInfo?.latestPrds}
        greyTitle="Leve seus bebezinhos para onde quiser!"
        purpleSubTitle="As séries recentemente adicionadas estão aqui"
      />
    </Box>
  );
}
